import React, { useState } from 'react'
import { getMainCategoryIcon } from '@dustin-web/microsite-components/src/utils/main-category-icons'
import ExpandButton from '@dustin-web/microsite-components/src/expand-button'
import { useTranslations } from '@dustin-web/microsite-components/src/hooks'
import { Maybe, NavigationItemFragment } from 'src/graphql/generated/graphql-types'
import classNames from 'classnames'

type Props = {
  categoryId: string
  category: {
    id: string
    seoText?: Maybe<string>
    name?: string | null
    navigation?: Maybe<{
      path: Array<NavigationItemFragment>
    }>
    seoLongTitleName?: string | null
  }
}

const CategorySEOContent = ({ category, categoryId }: Props) => {
  const [contentReadMoreOpen, setContentReadMoreOpen] = useState(false)
  const { translate } = useTranslations()

  const isMainCategory = category.navigation?.path.length === 2
  const isLongText = (category.seoText?.length ?? 0) > 600

  return (
    <div className="row">
      <div className="col-12 col-md-4 u-mb-md-0 u-mb-8">
        <h1 className="d-flex h2">
          {isMainCategory ? getMainCategoryIcon(categoryId, 'u-mr-12 i-32 i-gray-10') : null}
          <div>{category.seoLongTitleName || category.name}</div>
        </h1>
      </div>
      {category.seoText && (
        <div className="col-12 col-md-8 col-lg-7">
          <div
            className={classNames('u-overflow-hidden c-category-seo-content', {
              'u-mb-32': isLongText,
            })}
            id="content"
            style={{
              height: contentReadMoreOpen || !isLongText ? undefined : '110px',
              maxHeight: contentReadMoreOpen || !isLongText ? '1600px' : '110px',
              transition: 'max-height 0.5s ease',
            }}
            dangerouslySetInnerHTML={{ __html: category.seoText }}></div>
          {isLongText && (
            <div className="u-relative">
              <div
                className={classNames('c-category-seo-content__read-more', {
                  'c-category-seo-content__read-more-closed': !contentReadMoreOpen,
                  'c-category-seo-content__read-more-open': contentReadMoreOpen,
                })}>
                <ExpandButton
                  collapsedTitle={translate('ReadMore')}
                  expandedTitle={translate('Hide')}
                  expanded={contentReadMoreOpen}
                  onClick={() => setContentReadMoreOpen(!contentReadMoreOpen)}
                  ariaControls="content"
                />
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default CategorySEOContent
